export const BROKERAGE_SCHWAB = 'schwab';
export const BROKERAGE_TRADOVATE = 'tradovate';

export const TENANT_INVESTCEO = 'investceo';
export const TENANT_OPTIONGENIUS = 'optiongenius';

export const TENANT_BROKERAGE_MAP = {
    [TENANT_INVESTCEO]: [BROKERAGE_TRADOVATE],
    [TENANT_OPTIONGENIUS]: [BROKERAGE_SCHWAB],
};